export default __webpack_public_path__ + "static/media/blog-back.fc0b4338.svg";